import React, { Component } from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import UAParser from "ua-parser-js";
import _ from "lodash";
import { MuiThemeProvider } from "@material-ui/core/styles";

// Local modules
import Toolbar from "./Toolbar";
import AgentList from "./AgentList";
import Styles from "./styles";
import Store from "./Store";
import AceTheme from "../../util/aceTheme";

const parser = new UAParser();
const deviceType = parser.getResult().device.type;
const isMobile = deviceType === "mobile" || deviceType === "tablet";

@observer
class InactiveList extends Component {
  componentDidMount() {
    Store.getAgentList();
  }

  render() {
    const { classes } = this.props;
    return (
      <MuiThemeProvider theme={AceTheme}>
        <Toolbar
          {...{
            classes: classes,
            weeks: _.range(8),
            selectProps: this.selectProps,
            search: this.search,
          }}
        />

        <Grid container spacing={0} className={classes.content}>
          {!Store.loading && !_.isEmpty(Store.agentList) && (
            <AgentList
              {...{
                agentList: Store.agentList,
                isMobile: isMobile,
              }}
            />
          )}
          {Store.loading && _.isEmpty(Store.agentList) && (
            <Grid item md={6} sm={12} xs={12}>
              <LinearProgress className={classes.progressLinear} />
            </Grid>
          )}
          {!Store.loading && _.isEmpty(Store.agentList) && (
            <Grid item md={6} sm={12} xs={12}>
              <Typography align="left">No agents to show.</Typography>
            </Grid>
          )}
          <Grid item md={6} sm={12} xs={12} className={classes.infoBox}>
            <Typography variant="headline" align="left" gutterBottom>
              Found {_.size(Store.agentList)} agents that have been inactive for
              at least {Store.weeks} week
              {Store.weeks > 1 ? "s" : ""}.
            </Typography>
            <Typography align="left">
              Note: An agent is considered inactive if the players under his
              account does not have any activity <br /> during the requested
              period. Inactive agents are not included in the report.
            </Typography>
          </Grid>
        </Grid>
      </MuiThemeProvider>
    );
  }

  search() {
    Store.getAgentList();
  }

  selectProps = (id, type, helperTxt) => {
    return {
      id: id,
      select: true,
      label: "",
      className: this.props.classes.textField,
      helperText: !isMobile ? helperTxt : "",
      margin: "none",
      value: Store[type],
      onChange: this.handleChange(type),
      inputProps: {
        className: this.props.classes.inputStyle,
      },
    };
  };

  handleChange = (name) => (event) => {
    Store.handleDropdown(name, event.target.value);
  };
}

InactiveList.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default compose(
  withStyles(Styles, {
    name: "InactiveList",
    withTheme: true,
  })
)(InactiveList);
